import { BannerProvider } from '@/components/common/banner/BannerProvider';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { AdapterDateFns as DateAdapter } from '@mui/x-date-pickers/AdapterDateFns';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { ReCaptchaProvider } from '@/app/provider/ReCaptchaProvider';
import { Root } from '@/components/Root';
import { persistor, store } from '@/app/store';
import { ru } from 'date-fns/locale';
import React, { FC, ReactElement } from 'react';
import theme from '@/app/theme';
import '@assets/styles/index.scss';

export const App: FC = (): ReactElement => {
  return (
    <HelmetProvider>
      <LocalizationProvider
        dateAdapter={DateAdapter}
        adapterLocale={ru as never}
        localeText={{ fieldYearPlaceholder: () => 'ГГГГ' }}>
        <Provider store={store}>
          <ReCaptchaProvider>
            <PersistGate loading={null} persistor={persistor}>
              <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <BannerProvider>
                  <Root />
                </BannerProvider>
              </MuiThemeProvider>
            </PersistGate>
          </ReCaptchaProvider>
        </Provider>
      </LocalizationProvider>
    </HelmetProvider>
  );
};
